// Mobile menu logic
jQuery(document).ready(function ($) {
  let mobilemenu_open = false;
  const $open = $("#mobile-menu-open");
  const $close = $("#mobile-menu-close");
  const $menu = $("#mobile-menu");
  const $mobileHeader = $("#full-mobile-header");
  const $divider = $("#full-mobile-header .divider");

  $open.on("click", function () {
    $menu.removeClass("!hidden");
    $mobileHeader.addClass("h-svh");
    $divider.addClass("hidden");
    $("body").addClass("menu-open");
  });

  $close.on("click", function () {
    $menu.addClass("!hidden");
    $mobileHeader.removeClass("h-svh");
    $divider.removeClass("hidden");
    $("body").removeClass("menu-open");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll('.mobile-menu-walker [data-toggle="accordion"]');

  toggles.forEach((toggle) => {
    const toggleButton = toggle.querySelector(".accordion-toggle");
    const submenu = toggle.querySelector(".accordion-content");
    const svg = toggle.querySelector(".chevron");

    if (toggleButton) {
      toggleButton.addEventListener("click", function (e) {
        e.preventDefault();

        const isOpen = !submenu.classList.contains("hidden");

        if (!isOpen) {
          // Open current submenu
          submenu.classList.remove("hidden");
          submenu.classList.add("block");
          svg?.classList.add("rotate-180");

          // Find nested children and open them
          const nestedToggles = submenu.querySelectorAll(".nested-child[data-toggle='accordion']");
          nestedToggles.forEach((nested) => {
            const nestedSub = nested.querySelector(".accordion-content");
            const nestedToggleBtn = nested.querySelector(".accordion-toggle");
            const nestedSvg = nested.querySelector(".chevron");

            nestedSub?.classList.remove("hidden");
            nestedSub?.classList.add("block");

            // Remove the toggle button for nested children
            nestedToggleBtn?.remove();

            // Adjust SVG if still present
            nestedSvg?.classList.add("rotate-180");
          });

        } else {
          // Close current submenu
          submenu.classList.remove("block");
          submenu.classList.add("hidden");
          svg?.classList.remove("rotate-180");
        }
      });
    }
  });
});
